<div>
  <ion-grid style="max-width: 1000px">
    <ion-row *ngIf="showInlineSelector">
      <ion-col class="ion-text-center">
        <label
          *ngIf="isBrowserPlatform"
          for="file-upload"
          class="custom-file-upload"
        >
          <ion-icon name="cloud-upload"></ion-icon>
          {{ "account-settings.upload-photo" | translate }}
        </label>
        <input
          *ngIf="isBrowserPlatform"
          id="file-upload"
          #fileUploadInput
          type="file"
          accept="image/png, image/jpeg, image/webp"
          (change)="onFileChanged($event)"
        />
        <ion-button
          *ngIf="!isBrowserPlatform"
          fill="outline"
          color="primary"
          (click)="selectImageFromDevice()"
        >
          <ion-icon slot="start" name="camera-outline"></ion-icon>
          {{ "account-settings.take-or-choose-photo" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
    <input
      *ngIf="isBrowserPlatform && !showInlineSelector"
      id="file-upload"
      #fileUploadInput
      type="file"
      accept="image/png, image/jpeg, image/webp"
      (change)="onFileChanged($event)"
    />
    <ion-row *ngIf="showCurrentPreview && !showCropper" class="ion-padding-top">
      <ion-col class="ion-text-center">
        <div class="currentProfileImageWrapper">
          <ion-avatar class="currentProfileAvatar">
            <img
              *ngIf="currentProfileImageSrc"
              class="currentProfileImage"
              [src]="currentProfileImageSrc"
            />
            <ng-lottie
              *ngIf="!currentProfileImageSrc"
              (animationCreated)="animationCreated($event)"
              [options]="options"
            >
            </ng-lottie>
          </ion-avatar>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      style="width: 100%"
      class="ion-align-items-center ion-justify-content-center"
    >
      <ion-col size="12" class="ion-text-center">
        <image-cropper
          class="profileImageCropper"
          [imageFile]="selectedImageFile"
          format="jpeg"
          [aspectRatio]="4 / 4"
          [maintainAspectRatio]="true"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [cropperMinWidth]="128"
          [onlyScaleDown]="true"
          [roundCropper]="true"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="'center'"
          [style.display]="showCropper ? null : 'none'"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady($event)"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="uploadProgress">
      <ion-col>
        <ion-progress-bar [value]="uploadProgress"></ion-progress-bar>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
